import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";
import { type BaseLeaveRequest } from "@/lib/collections/requestsLeave/types";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const LEAVES_COLLECTION_ID = import.meta.env.VITE_LEAVES_REQUESTS_COLLECTION_ID;

export type LeaveRequest = BaseLeaveRequest;

export async function getLeaveRequestsByUser(userId: string) {
    try {
        const response = await databases.listDocuments(
            DATABASE_ID,
            LEAVES_COLLECTION_ID,
            [
                Query.equal("userId", userId),
                Query.orderDesc("$createdAt")
            ]
        );

        return {
            success: true,
            data: response.documents as unknown as LeaveRequest[]
        };
    } catch (error) {
        console.error("Error fetching leave requests:", error);
        return {
            success: false,
            data: null,
            error
        };
    }
}